import * as React from "react";
import styled, { css, useTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { Progress, Text, Title } from "components/common";
import NumberUtils from "util/NumberUtils";
const StyledTitle = styled(Title)(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.xs};
  `
);
const Description = styled(Text)(
  ({ theme }) => css`
    color: ${theme.colors.gray[50]};
    margin-bottom: ${theme.spacings.md};
  `
);
const VolumeProgressRoot = styled(Progress.Root)(
  ({ theme }) => css`
    background-color: ${theme.colors.gray[90]};
    margin-bottom: ${theme.spacings.xxs};
  `
);
const DataLakeVolumeSection = ({ volume }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const theme = useTheme();
  const progressColor = (pct) => {
    if (pct >= 90) return theme.colors.variant.danger;
    if (pct >= 70) return theme.colors.variant.warning;
    return theme.colors.variant.success;
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledTitle, { order: 2 }, t("volume.title")), /* @__PURE__ */ React.createElement(Description, null, t("volume.description")), /* @__PURE__ */ React.createElement(VolumeProgressRoot, { size: "lg" }, /* @__PURE__ */ React.createElement(Progress.Section, { value: volume.usagePercentage, color: progressColor(volume.usagePercentage) })), /* @__PURE__ */ React.createElement("span", null, NumberUtils.formatBytes(volume.totalBytes)), " \xB7 ", /* @__PURE__ */ React.createElement("span", null, NumberUtils.formatPercentage(volume.usagePercentage / 100)), ` ${t("volume.used")}`);
};
export default DataLakeVolumeSection;
